/* eslint-disable max-len */
import React from "react";
import {Link} from "react-router-dom";
import {Box} from "@mui/material";
import {PoliciesStyledBox} from "lib/components";

export default function DataPrivacy() {
  return (
    <PoliciesStyledBox>
      <Box sx={{width: {xs: "100%", sm: "90%"}}}>
        <h3>Data Privacy</h3>
        <p>
          <strong>Last updated: April 5, 2025</strong>
        </p>

        <p>
          At <strong>Maritime IT Solutions LLC</strong>, the trust of our customers is paramount. We continuously
          monitor the evolving landscape of privacy regulations and legislation to ensure compliance and maintain your
          trust. Our commitment to safeguarding your data is unwavering, and we strive to keep you informed about our
          privacy and data security policies, practices, and technologies. Below, we outline our key commitments to
          protecting your data:
        </p>

        <h4>Access</h4>
        <p>
          As a customer, you retain full control over your content and data uploaded to <em>CrewBook</em>. Leveraging{" "}
          <strong>Amazon Web Services (AWS)</strong>, we provide advanced access, encryption, and logging features to
          help you manage your data securely. AWS APIs are configured to enforce strict access control permissions for
          all services powering CrewBook. We do not access or use your content for any purpose without your explicit
          consent, and we never use your data for marketing or advertising.
        </p>

        <h4>Storage</h4>
        <p>
          Your data is securely stored using <strong>Amazon S3</strong>, a highly durable object storage service
          designed to retrieve any amount of data from anywhere. AWS S3 offers industry-leading durability, with a{" "}
          <em>99.999999999% (11 nines)</em> failure tolerance, ensuring your data is protected against loss.
          Additionally, AWS S3 provides unmatched security, compliance, and audit capabilities. We will not move or
          replicate your data without your consent, except as required by law or a binding government order.
        </p>

        <h4>Security</h4>
        <p>
          <em>CrewBook</em>, powered by AWS, employs industry-leading encryption to protect your data both in transit
          and at rest. Our data protection features include:
        </p>
        <ul>
          <li>Full data encryption across all AWS services configured for CrewBook.</li>
          <li>
            <strong>AWS Key Management Service (KMS)</strong>, which provides centralized control over the cryptographic
            keys used to safeguard your data.
          </li>
        </ul>

        <h4>Disclosure of Customer Content</h4>
        <p>
          We will not disclose your content unless compelled to do so by law or a binding government order. In such
          cases, we will notify you, unless prohibited by law, and take steps to protect your rights.
        </p>

        <h4>Security Assurance</h4>
        <p>
          We maintain a robust security assurance program, adhering to global best practices for privacy and data
          protection. This program ensures that <em>CrewBook</em> operates securely, leveraging AWS’s comprehensive
          security control environment to meet the highest standards of data protection.
        </p>

        <h4>Contact Us</h4>
        <p>If you have any questions about our Data Privacy practices, please contact us:</p>
        <ul>
          <li>
            <strong>By email:</strong> <a href="mailto:watchkeeper@crewbook.app">watchkeeper@crewbook.app</a>
          </li>
          <li>
            <strong>By visiting:</strong> <Link to="/contact">https://www.crewbook.app/contact</Link>
          </li>
        </ul>
      </Box>
    </PoliciesStyledBox>
  );
}
